document.addEventListener("DOMContentLoaded", () => {
  const slot = document.querySelector("#tpa-bidbox-slot");
  if (!slot) return;

  const WIDGET_SELECTOR = ".tpa-product-widget-wrapper";

  const move = () => {
    const widgets = Array.from(document.querySelectorAll(WIDGET_SELECTOR));
    if (!widgets.length) return false;

    const widget = widgets[0];
    widgets.slice(1).forEach(w => w.remove()); // falls doppelt gerendert
    slot.appendChild(widget);
    return true;
  };

  if (move()) return;

  const obs = new MutationObserver(() => {
    if (move()) obs.disconnect();
  });

  obs.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => obs.disconnect(), 10000);
});